class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-banner__dot'));
    this.prevBtn = this.querySelector('.hero-banner__arrow--prev');
    this.nextBtn = this.querySelector('.hero-banner__arrow--next');
    this.count = this.slides.length;
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 6000;
    this.timer = null;
    this.touchStartX = null;

    if (this.count < 2) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10))));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.addEventListener('touchstart', (e) => { this.touchStartX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (this.touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(delta) > 40) this.go(this.current + (delta < 0 ? 1 : -1));
      this.touchStartX = null;
    }, { passive: true });

    this.start();
  }

  go(index) {
    const next = (index + this.count) % this.count;
    if (next === this.current) return;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.slides[next].classList.add('is-active');
    this.dots[next] && this.dots[next].classList.add('is-active');
    this.current = next;
  }

  start() {
    if (!this.autoplay || this.count < 2) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('hero-banner', HeroBanner);
